import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModules } from './app.material';
import { LoginComponent } from './components/login/login.compnent';
import {ConfirmDialogComponent} from './core/popupmessage/popupmessage.component'
import { DynamicDialog } from './core/popupmessage/dynamicdialog/dynamicdialog.component';
import {NavagationModule} from './components/navigation/navigation.module';
import { UtilityService } from './services/utility.service';
import { NavGuardService } from './components/navigation/nav.gaurd.service';
import { AccessGuardService } from './services/accessguard.service';
import { PopupService } from './core/popupmessage/popupmessage.service';
import { DynamicDialogService } from './core/popupmessage/dynamicdialog/dynamicdialog.service';
import { PageMessagesService } from './services/pagemessages.services';
import { UserService } from './services/user.service';
import { LoginGuard } from './components/login/login-gaurd.service';
import { AuthenticationService } from './services/authentication.service';
import {InputService} from './core/dynamicform/input.service'
import {InputControlService} from './core/dynamicform/inputcontrol.service';
import { NavigationService } from './services/nav.service';
import { SettingsService } from './services/settings.service';
import { DeliveryRateFinderModule } from './components/deliveryRateFinder/DeliveryRateFinder.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { QuarriesService } from './services/quarries.service';
import { DeliveryRateService } from './services/deliveryRate.service';
import { MapsService } from './services/maps.service';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmDialogComponent,
    DynamicDialog
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModules,
    NavagationModule,
    DeliveryRateFinderModule,
    GoogleMapsModule
  ],
  providers: [
    UtilityService,
    NavGuardService,
    AccessGuardService,
    PopupService,
    DynamicDialogService,
    PageMessagesService,
    UserService,
    LoginGuard,
    AuthenticationService,
    NavigationService,
    InputService,
    InputControlService,
    SettingsService,
    QuarriesService,
    DeliveryRateService,
    MapsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
